import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ChevronLeftRounded({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ChevronLeftRounded.Outline {...props} />
  ) : (
    <ChevronLeftRounded.Solid {...props} />
  );
}

ChevronLeftRounded.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ChevronLeftRounded.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M11.9716 7.06052C12.2651 6.76826 12.2661 6.29339 11.9739 5.99987C11.6816 5.70634 11.2067 5.70532 10.9132 5.99758L7.4272 9.46858C7.28584 9.60932 7.20638 9.80058 7.20638 10.0001C7.20638 10.1995 7.28584 10.3908 7.4272 10.5315L10.9132 14.0025C11.2067 14.2948 11.6816 14.2938 11.9739 14.0002C12.2661 13.7067 12.2651 13.2318 11.9716 12.9396L9.01934 10.0001L11.9716 7.06052Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10.0002C20 4.47698 15.5222 0.000244141 10 0.000244141C4.47784 0.000244141 0 4.47698 0 10.0002C0 15.5225 4.47779 20.0002 10 20.0002C15.5222 20.0002 20 15.5225 20 10.0002ZM10 1.50024C14.6938 1.50024 18.5 5.30551 18.5 10.0002C18.5 14.694 14.6938 18.5002 10 18.5002C5.30621 18.5002 1.5 14.694 1.5 10.0002C1.5 5.30551 5.30616 1.50024 10 1.50024Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
